exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-groups-timeslotcolumn-style__noAppointments{height:80px;width:100%;background-color:#f7f7fc;border-radius:6px;display:flex!important;justify-content:center;align-items:center;color:#29323b;font-family:Lato;font-size:12px;font-style:normal;font-weight:600;line-height:normal;letter-spacing:.036px}.nil-sa-groups-timeslotcolumn-style__hideSlot{display:none!important}", ""]);

// exports
exports.locals = {
	"noAppointments": "nil-sa-groups-timeslotcolumn-style__noAppointments",
	"hideSlot": "nil-sa-groups-timeslotcolumn-style__hideSlot"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/groups/TimeSlotColumn/style.less
// module id = 433
// module chunks = 0